import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceScheduleHistoryModalComponent } from '@app/features/services/components/service-schedule-history-modal/service-schedule-history-modal.component';
import { SiteDetailComponent } from '@app/features/services/pages/site-detail/site-detail.component';
import { SharedModule } from '@app/shared/shared.module';
import { OnetimeservicesListTableComponent } from './components/onetimeservices-list-table/onetimeservices-list-table.component';
import { ServiceDayCirclesComponent } from './components/service-day-circles/service-day-circles.component';
import { ServiceSchedulesComponent } from './components/service-schedules/service-schedules.component';
import { SiteHaulerContractDocumentsComponent } from './components/site-hauler-contract-documents/site-hauler-contract-documents.component';
import { SiteListTableComponent } from './components/site-list-table/site-list-table.component';
import { CustomerInvoicesTableComponent } from './pages/customer-invoices-table/customer-invoices-table.component';
import { OnetimeservicesListComponent } from './pages/onetimeservices-list/onetimeservices-list.component';
import { SiteDetailGeneralComponent } from './pages/site-detail-general/site-detail-general.component';
import { SiteListComponent } from './pages/site-list/site-list.component';
import { ServicesRoutingModule } from './services-routing.module';
import { ServicesComponent } from './services.component';

const components = [
  ServicesComponent,
  ServiceSchedulesComponent,
  SiteDetailComponent,
  SiteDetailGeneralComponent,
  ServiceScheduleHistoryModalComponent,
  SiteListComponent,
  SiteListTableComponent,
  ServiceDayCirclesComponent,
  CustomerInvoicesTableComponent,
];

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    ServicesRoutingModule,
  ],
  declarations: [
    ...components,
    OnetimeservicesListTableComponent,
    OnetimeservicesListComponent,
    SiteHaulerContractDocumentsComponent,
  ],
  exports: [],
})
export class ServicesModule {}
